/* eslint-disable */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Drawer from '@mui/material/Drawer';
// import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import ListItemButton from '@mui/material/ListItemButton';
import { useDataContext } from '../../context/index';

import { usePathname } from 'src/routes/hooks';
import { RouterLink } from 'src/routes/components';

import { useResponsive } from 'src/hooks/use-responsive';

import { account } from 'src/_mock/account';
import NavMenuIcon from './NavMenuIcon';

import Logo from 'src/components/logo';
import Scrollbar from 'src/components/scrollbar';

import { NAV } from './config-layout';
import navConfig from './config-navigation';
import { canManageBaiboon } from 'src/utils/baiboonAccess';
import { Collapse, List, ListItemIcon, ListItemText, Tooltip, IconButton } from '@mui/material';
import { UpOutlined, DownOutlined, CaretUpOutlined, CaretDownOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { useCookies } from 'react-cookie';
import { jwtDecode } from 'jwt-decode';
import { Badge } from 'antd';
import { useNavigate } from 'react-router-dom';
import { canAccessOtCosting } from 'src/utils/otCostingAccess';
import { canAccessManageWelfare } from 'src/utils/welfareAccess';
import { canSeeEvalHrMenus, isEvaluationHr } from 'src/utils/evaluationAccess';
const API_URL = import.meta.env.VITE_API_URL;
const SHOW_MANAGE_AD_MENU = false;

const NavLayoutContext = React.createContext({
  mini: false,
  requestExpand: () => {},
});

// ----------------------------------------------------------------------

export default function Nav({
  openNav,
  onCloseNav,
  navMini = false,
  onToggleMini,
  onExpandNav,
}) {
  const [cookies, setCookie] = useCookies(['session']);
  const { data, setData } = useDataContext();
  const navigate = useNavigate();

  // ใน Nav function
  const decodedToken = React.useMemo(() => {
    try {
      return cookies?.session ? jwtDecode(cookies.session) : null;
    } catch (error) {
      return null;
    }
  }, [cookies?.session]);
  console.log('🚀 ~ Nav ~ decodedToken:', decodedToken);

  const [name, setName] = useState(null);
  console.log('🚀 ~ Nav ~ name:', name);
  const [candidate, setCandidate] = useState(null);
  const sessionToken = cookies?.session;

  useEffect(() => {
    // ตรวจสอบและถอดรหัส token
    let decodedToken = null;
    let decodedCandidateToken = null;
    try {
      if (cookies?.session && typeof cookies.session === 'string') {
        decodedToken = jwtDecode(cookies.session);
        decodedCandidateToken = jwtDecode(sessionToken);
      } else {
        console.warn('Invalid or missing session cookie');
      }
    } catch (error) {
      console.error('Error decoding token:', error.message);
    }

    // หา employeeId ตาม userId
    if (decodedToken) {
      const foundEmployee = data?.getAllEmployees?.find((employee) => {
        return (
             (employee.username && decodedToken?.initials && employee.username === decodedToken.initials) ||
          (employee.employeeCode && decodedToken?.UserCode && employee.employeeCode === decodedToken.UserCode) ||
          (employee.email && decodedToken?.Email && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.Email.replace(/\s/g, '').toLowerCase()) ||
          (employee.email && decodedToken?.mail && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.mail.replace(/\s/g, '').toLowerCase()) ||
          (employee.email && decodedToken?.preferred_username && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.preferred_username.replace(/\s/g, '').toLowerCase()) ||
          (employee.email && decodedToken?.userPrincipalName && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.userPrincipalName.replace(/\s/g, '').toLowerCase())
        );
      });
      console.log('🚀 ~ Nav ~ foundEmployee:', foundEmployee);
      setName(foundEmployee);
      setCandidate(decodedCandidateToken);
    }
  }, [cookies, data]);
  const pathname = usePathname();

  const upLg = useResponsive('up', 'lg');
  const navWidth = navMini ? NAV.WIDTH_MINI : NAV.WIDTH;
  const layoutCtx = React.useMemo(
    () => ({
      mini: Boolean(navMini && upLg),
      requestExpand: () => {
        if (typeof onExpandNav === 'function') onExpandNav();
      },
    }),
    [navMini, upLg, onExpandNav]
  );

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderAccount = (
    <Box
      onClick={() => {
        if (!candidate?.candidateId) {
          navigate(`/employee/${name?.employeeCode}`);
        } else {
          navigate(`/profile`);
        }
      }}
      sx={{
        my: 3,
        mx: navMini ? 1 : 2.5,
        py: navMini ? 1 : 2,
        px: navMini ? 1 : 2.5,
        display: 'flex',
        borderRadius: 1.5,
        alignItems: 'center',
        justifyContent: navMini ? 'center' : 'flex-start',
        bgcolor: (theme) => alpha(theme.palette.grey[500], 0.12),
        cursor: 'pointer',
      }}
    >
      <Avatar
        src={
          name?.employeeCode
            ? `https://api-hr.boonsiri.co.th/public/images/profile/${name?.employeeCode}_1.jpg`
            : data?.getCandidate?.profileImage
            ? `https://api-hr.boonsiri.co.th${data?.getCandidate?.profileImage}`
            : 'https://mui.com/static/images/avatar/16.jpg'
        }
        alt={
          name?.nameTh === 'null null'
            ? 'ไม่ได้ระบุชื่อ'
            : name?.nameTh || decodedToken?.nameTh === 'null null'
            ? data?.getCandidate?.firstName
              ? data?.getCandidate?.firstName
              : 'ไม่ได้ระบุชื่อ'
            : decodedToken?.nameTh || 'ไม่ได้ระบุชื่อ'
        }
        imgProps={{
          style: {
            objectFit: 'cover',
            objectPosition: 'top',
          },
        }}
      />

      {!navMini && (
        <Box sx={{ ml: 2 }}>
          <Typography variant="subtitle2">
            {name?.nameTh === 'null null'
              ? 'ไม่ได้ระบุชื่อ'
              : name?.nameTh || decodedToken?.nameTh === 'null null'
              ? data?.getCandidate?.firstName
                ? `${data?.getCandidate?.firstName} ${data?.getCandidate?.lastName}`
                : name?.nameTh
                ? name?.nameTh
                : 'ไม่ได้ระบุชื่อ'
              : decodedToken?.nameTh || 'ไม่ได้ระบุชื่อ'}
          </Typography>

          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {account.role}
          </Typography>
        </Box>
      )}
    </Box>
  );

  const test = 12;

  const renderMenu = (
    <Stack component="nav" spacing={0.5} sx={{ px: navMini ? 1 : 2 }}>
      {navConfig
        .filter(
          (item) =>
            (!decodedToken?.candidateId &&
              item.title !== 'ตำแหน่งที่เปิดรับสมัคร' &&
              item.title !== 'งานที่สมัคร' &&
              item.title !== 'งานที่สนใจ') ||
            (decodedToken?.candidateId &&
              (item.title === 'ตำแหน่งที่เปิดรับสมัคร' ||
                item.title === 'งานที่สมัคร' ||
                item.title === 'งานที่สนใจ'))
        )
        .map((item) => (
          <NavItem key={item.title} item={item} />
        ))}
    </Stack>
  );

  const renderUpgrade = (
    <Box sx={{ px: 2.5, pb: 3, mt: 10 }}>
      <Stack
        alignItems="center"
        spacing={3}
        sx={{ pt: 5, borderRadius: 2, position: 'relative' }}
      ></Stack>
    </Box>
  );

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Box
        sx={{
          mt: 3,
          px: navMini ? 1 : 2,
          display: 'flex',
          flexDirection: navMini ? 'column' : 'row',
          alignItems: 'center',
          justifyContent: navMini ? 'center' : 'space-between',
          gap: 1,
          minHeight: 40,
        }}
      >
        <Logo sx={{ ...(navMini ? { width: 40, ml: 0 } : { ml: 2 }) }} />
        {upLg && typeof onToggleMini === 'function' && (
          <Tooltip title={navMini ? 'ขยายเมนู' : 'ย่อเมนู'} placement="right">
            <IconButton
              size="small"
              onClick={onToggleMini}
              aria-label={navMini ? 'ขยายเมนู' : 'ย่อเมนู'}
              sx={{ flexShrink: 0 }}
            >
              {navMini ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </IconButton>
          </Tooltip>
        )}
      </Box>

      {renderAccount}

      {renderMenu}

      <Box sx={{ flexGrow: 1 }} />

      {renderUpgrade}
    </Scrollbar>
  );

  return (
    <NavLayoutContext.Provider value={layoutCtx}>
      <Box
        sx={{
          flexShrink: { lg: 0 },
          width: { lg: navWidth },
          transition: (theme) =>
            theme.transitions.create('width', { duration: theme.transitions.duration.shorter }),
        }}
      >
        {upLg ? (
          <Box
            sx={{
              height: 1,
              position: 'fixed',
              width: navWidth,
              borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
              transition: (theme) =>
                theme.transitions.create('width', { duration: theme.transitions.duration.shorter }),
              overflowX: 'hidden',
            }}
          >
            {renderContent}
          </Box>
        ) : (
          <Drawer
            open={openNav}
            onClose={onCloseNav}
            PaperProps={{
              sx: {
                width: NAV.WIDTH,
              },
            }}
          >
            {renderContent}
          </Drawer>
        )}
      </Box>
    </NavLayoutContext.Provider>
  );
}

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
  navMini: PropTypes.bool,
  onToggleMini: PropTypes.func,
  onExpandNav: PropTypes.func,
};

// ----------------------------------------------------------------------

function NavItem({ item }) {
  const [cookies] = useCookies(['session']);
  // ✅ 1. เรียกใช้ data จาก Context โดยตรง
  const { data } = useDataContext();
  const { mini, requestExpand } = React.useContext(NavLayoutContext);

  // แปลง Token (ใช้ useMemo เพื่อไม่ให้ decode ซ้ำ)
  const decodedToken = React.useMemo(() => {
    try {
      return cookies?.session ? jwtDecode(cookies.session) : null;
    } catch (e) {
      return null;
    }
  }, [cookies?.session]);

  const [name, setName] = useState(null);
  console.log('🚀 ~ NavItem ~ name:', name);

  // ✅ 2. Logic หา User ปัจจุบัน (ดึงจาก data.getAllEmployees ที่โหลดมาแล้ว)
  useEffect(() => {
    if (decodedToken && data?.getAllEmployees) {
      const foundEmployee = data.getAllEmployees.find(
        (employee) =>
             (employee.username && decodedToken?.initials && employee.username === decodedToken.initials) ||
          (employee.employeeCode && decodedToken?.UserCode && employee.employeeCode === decodedToken.UserCode) ||
          (employee.email && decodedToken?.Email && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.Email.replace(/\s/g, '').toLowerCase()) ||
          (employee.email && decodedToken?.mail && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.mail.replace(/\s/g, '').toLowerCase()) ||
          (employee.email && decodedToken?.preferred_username && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.preferred_username.replace(/\s/g, '').toLowerCase()) ||
          (employee.email && decodedToken?.userPrincipalName && employee.email.replace(/\s/g, '').toLowerCase() === decodedToken.userPrincipalName.replace(/\s/g, '').toLowerCase())
      );
      setName(foundEmployee);
    }
  }, [decodedToken, data?.getAllEmployees]);

  let emp = name;
  const pathname = usePathname();
  const active = item.path === pathname;

  // State เมนูเปิด/ปิด (คงเดิม)
  const [open, setOpen] = React.useState(false);
  const [openHome, setOpenHome] = React.useState(false);
  const [openDataEm, setOpenDataEm] = React.useState(false);
  const [openOrientation, setOpenOrientation] = React.useState(false);
  const [openEvalution, setOpenEvalution] = React.useState(false);
  const [openRecruit, setOpenRecruit] = React.useState(false);
  const [openResign, setOpenResign] = React.useState(false);
  const [openReport, setOpenReport] = React.useState(false);
  const [openReward, setOpenReward] = React.useState(false);
  const [openOther, setOpenOther] = React.useState(false);

  // State Check Active Submenu (คงเดิม)
  const isManageDeptActive = pathname === '/manageDept';
  const isManageDeptFactActive = pathname === '/manageDeptFact';
  const isManageAllEmployeeActive = pathname === '/manageEmployee';
  const isManageUser = pathname === '/manageUser';
  const isConsent = pathname === '/consent';
  const isManageHealth = pathname === '/manageHealth';
  const isManageWelfare = pathname === '/manageWelfare';
  const isEmployeeDamageOrLoan = pathname === '/employeeDamageOrLoan';
  const isMyCalendar = pathname === '/myCalendar';
  const isReqEditCalendar = pathname === '/reqEditCalendar';
  const isPromoteCandidate = pathname === '/promoteCandidate';
  const isPrepareAssignAsset = pathname === '/prepareAssignAsset';
  const isTrainingHistory = pathname === '/trainingHistory';
  const isTrainingRequest = pathname === '/trainingRequest';
  const isTrainingData = pathname === '/trainingData';
  const isTrainingPlan = pathname === '/trainingPlan';
  const isTrainingSkillNeed = pathname === '/trainingSkillNeed';
  const isTrainingCompliance = pathname === '/trainingCompliance';
  const isTrainingDsd = pathname === '/trainingDsd';
  const isTrainingCertificate = pathname === '/trainingCertificate';
  const isProbationEva = pathname === '/probationEva';
  const isProbationEvaMe = pathname === '/probationEvaMe';
  const isProbationEvaYear = pathname === '/probationEvaYear';
  const isProbationEvaYearMe = pathname === '/probationEvaYearMe';
  const isSettingTest = pathname === '/settingTest';
  const isSummaryProbationEvaYear = pathname === '/summaryProbationEvaYear';
  const isKpiProbationEvaYear = pathname === '/summaryKpiProbationEvaYear';
  const isBehaviorDisciplineEvaYear = pathname === '/behaviorDisciplineEvaYear';
  const isTestTalentAssessment = pathname === '/testTalentAssessment';
  const isEvaluationSkillGap = pathname === '/evaluationSkillGap';
  const isTalentNineBox = pathname === '/talentNineBox';
  const isEvaluationRetention = pathname === '/evaluationRetention';
  const isEvaluationOkr = pathname === '/evaluationOkr';
  const isEvaluationPeerSummary = pathname === '/evaluationPeerSummary';
  // ponytail: Boonsiri Connect / น้องใบบุญ / Data Governance hidden from nav for now
  const isOtCosting = pathname === '/otCosting';
  const isReportEvaluation = pathname === '/reportEvaluation';
  const isDashboardProbationEva = pathname === '/dashboardProbationEva';
  const isDashboardProbationEvaYear = pathname === '/dashboardProbationEvaYear';
  const isManageTest = pathname === '/manageTest';
  const isListRecruit = pathname === '/listRecruit';
  const isCandidateEvaluation = pathname === '/candidateEvaluation';
  const isDeptOnOpen = pathname === '/deptOpen';
  const isReqEmployee = pathname === '/reqEmployee';
  const isApproveReqList = pathname === '/approveReqList';
  const isOrientation = pathname === '/orientation';
  const isManageAdOrganization = pathname === '/manageAdOrganization';
  const isManageAssets = pathname === '/manageAssets';
  const isManageChatId = pathname === '/manageChatId';
  const isBaiboonAdmin = pathname === '/baiboonAdmin';
  const isTestQuestions = pathname === '/testQuestions';
  const isDeptOpen = pathname === '/deptOpen';
  const isApplicationArchive = pathname === '/applicationArchive';
  const isResignation = pathname === '/resignation';
  const isResignationList = pathname === '/resignationList';
  const isReportEmployee = pathname === '/reportEmployee';
  const isOrganizationalChart = pathname === '/organizationalChart';
  const isReportResign = pathname === '/reportResign';
  const isLeaderBoard = pathname === '/leaderBoard';
  const isClaim = pathname === '/claim';
  const isTransferRequest = pathname === '/transferRequest';
  const isReward = pathname === '/reward';
  const isDocOther = pathname === '/docOther';
  const isDocument = pathname === '/document';
  const isReportSys = pathname === 'https://report.boonsiri.co.th';
  const isManageDoc = pathname === '/manageDoc';
  const isManageAllBranchActive = pathname === '/manageBranch';
  const isDashboard = pathname === '/';

  // Config Filter Status/Search (คงเดิม)
  const [search, setSearch] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [columnFilters, setColumnFilters] = useState({
    employeeCode: '',
    nameTh: '',
    nickname: '',
    branch: '',
    department: '',
    position: '',
    evaluator: '',
    evaluationType: '',
    evaluationStatus: '',
  });

  // --------------------------------------------------------------------------
  // 🚀 ส่วนที่แก้: ลบ fetch เดิมทิ้ง แล้วใช้ useMemo ดึงจาก Context แทน
  // --------------------------------------------------------------------------

  // 1. แปลง Evaluation Mappings
  const dataAllEvaluation = React.useMemo(() => {
    return (data.evaluationMappings || [])
      .filter((item) => item.isActive)
      .map((item) => ({
        evaluationId: item.mappingId,
        evaluationYear: item.evaluationYear,
        evaluationStatus: item.evaluationStatus || 'PENDING',
        employeeId: item.evaluateeId,
        evaluatorId: item.evaluatorId,
        evaluationType:
          item.ruleId === 2
            ? 'SELF'
            : item.ruleId === 3
            ? 'PEER'
            : item.ruleId === 4
            ? 'SUPERVISOR'
            : 'OTHER',
      }));
  }, [data.evaluationMappings]);

  // 2. คำนวณ Results/KPI/Behavior สำหรับ Badge Count
  const { results, filtered, resultsBehavior } = React.useMemo(() => {
    const evals = data.evaluationResults || [];
    // กรองเฉพาะ Supervisor (Rule 4)
    const selfResults = evals.filter((r) => r.ruleId === 4);

    return {
      results: selfResults,
      filtered: selfResults,
      resultsBehavior: selfResults,
    };
  }, [data.evaluationResults]);

  // Helper ดึงพนักงานจาก Context (แทนการวนลูป state)
  const getEmployee = (id) => data?.getAllEmployees?.find((emp) => emp.employeeId === id);

  // --------------------------------------------------------------------------
  // Logic Permission Filter (คงเดิม แต่ใช้ตัวแปรใหม่)
  // --------------------------------------------------------------------------
  const myEvaluations = dataAllEvaluation.filter((row) => row.evaluatorId === name?.employeeId);

  const myIsEvalHr = isEvaluationHr(emp);
  const myEmployeeCode = String(emp?.employeeCode || '').trim();
  const myEmployeeId = String(emp?.employeeId || '').trim();

  const filteredEvaAll = dataAllEvaluation?.filter((row) => {
    const targetEmp = getEmployee(row.employeeId);
    const evaluator = getEmployee(row.evaluatorId);

    let hasPermission = false;
    if (myIsEvalHr) {
      hasPermission = true;
    } else {
      const isSubordinate = String(targetEmp?.managerRefId || '').trim() === myEmployeeCode;
      const isAssignedToMe = String(row.evaluatorId) === myEmployeeId;
      const isMe = String(targetEmp?.employeeCode) === myEmployeeCode;
      hasPermission = isSubordinate; // ตาม Logic เดิมของคุณ
    }

    if (!hasPermission) return false;

    // Global Search Logic
    const globalMatch =
      !search ||
      targetEmp?.employeeCode?.toLowerCase().includes(search.toLowerCase()) ||
      targetEmp?.nameTh?.toLowerCase().includes(search.toLowerCase()) ||
      targetEmp?.nickname?.toLowerCase().includes(search.toLowerCase()) ||
      evaluator?.nameTh?.toLowerCase().includes(search.toLowerCase());

    const statusMatch = filterStatus === 'all' || row.evaluationStatus === filterStatus;

    return globalMatch && statusMatch;
  });

  const myFiltered = myEvaluations.filter((row) => {
    const matchStatus = filterStatus === 'all' || row.evaluationStatus === filterStatus;
    const matchSearch = !search;
    return matchStatus && matchSearch;
  });

  // Handle Click Functions — opening a group while mini expands the rail
  const openGroup = (currentlyOpen, setFn) => {
    const next = !currentlyOpen;
    if (next && mini) requestExpand();
    setFn(next);
  };
  const handleClick = () => openGroup(open, setOpen);
  const handleClickHome = () => openGroup(openHome, setOpenHome);
  const handleClickDataEm = () => openGroup(openDataEm, setOpenDataEm);
  const handleClickOrientation = () => openGroup(openOrientation, setOpenOrientation);
  const handleClickEvalution = () => openGroup(openEvalution, setOpenEvalution);
  const handleClickRecruit = () => openGroup(openRecruit, setOpenRecruit);
  const handleClickResign = () => openGroup(openResign, setOpenResign);
  const handleClickReport = () => openGroup(openReport, setOpenReport);
  const handleClickReward = () => openGroup(openReward, setOpenReward);
  const handleClickOther = () => openGroup(openOther, setOpenOther);

  // Mini rail cannot show indented submenu — close all groups when collapsing
  React.useEffect(() => {
    if (!mini) return;
    setOpen(false);
    setOpenHome(false);
    setOpenDataEm(false);
    setOpenOrientation(false);
    setOpenEvalution(false);
    setOpenRecruit(false);
    setOpenResign(false);
    setOpenReport(false);
    setOpenReward(false);
    setOpenOther(false);
  }, [mini]);

  // Return JSX (เหมือนเดิมทุกอย่าง)
  return (
    <>
      <Tooltip title={mini ? item.title : ''} placement="right">
      <ListItemButton
        onClick={(event) => {
          if (item.title === 'การจัดการ') {
            handleClick();
          }
          // else if (item.title === 'Home') {
          //   handleClickHome();
          // }
          else if (item.title === 'ข้อมูลพนักงาน') {
            handleClickDataEm();
          } else if (item.title === 'ฝึกอบรม') {
            handleClickOrientation();
          } else if (item.title === 'ประเมิน') {
            handleClickEvalution();
          } else if (item.title === 'สมัครงาน') {
            handleClickRecruit();
          } else if (item.title === 'ลาออก') {
            handleClickResign();
          } else if (item.title === 'รายงาน') {
            handleClickReport();
          } else if (item.title === 'สวัสดิการ') {
            handleClickReward();
          } else if (item.title === 'อื่นๆ') {
            handleClickOther();
          } else if (item.title === 'ระบบร้องเรียน') {
            event.preventDefault();
            window.open('https://report.boonsiri.co.th', '_blank', 'noopener,noreferrer');
          }
        }}
        component={RouterLink}
        to={item.title !== 'ระบบร้องเรียน' ? item.path : undefined}
        disabled={item.disabled}
        sx={{
          minHeight: 44,
          borderRadius: 0.75,
          justifyContent: mini ? 'center' : 'flex-start',
          px: mini ? 1 : undefined,
          display:
            item.title === 'การจัดการ'
              ? name?.organization?.level5 === 'ทรัพยากรบุคคล' ||
                name?.organization?.level4 === 'เทคโนโลยีและสารสนเทศ' ||
                name?.employeeCode === '012539'
                ? 'flex'
                : 'none'
              : 'flex',
          typography: 'body2',
          color: 'text.secondary',
          textTransform: 'capitalize',
          fontWeight: 'fontWeightMedium',
          ...(active && {
            color: 'primary.main',
            fontWeight: 'fontWeightSemiBold',
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
            '&:hover': {
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
            },
          }),
        }}
      >
        <Box component="span" sx={{ mr: mini ? 0 : 1.5, display: 'inline-flex', flexShrink: 0 }}>
          {React.isValidElement(item.icon)
            ? React.cloneElement(item.icon, {
                selected:
                  (item.title === 'Home' && active) ||
                  (item.title === 'ข้อมูลพนักงาน' && openDataEm) ||
                  (item.title === 'ฝึกอบรม' && openOrientation) ||
                  (item.title === 'ประเมิน' && openEvalution) ||
                  (item.title === 'สมัครงาน' && openRecruit) ||
                  (item.title === 'รายงาน' && openReport) ||
                  (item.title === 'สวัสดิการ' && openReward) ||
                  (item.title === 'อื่นๆ' && openOther) ||
                  (item.title === 'การจัดการ' && open) ||
                  (item.title === 'ลาออก' && openResign) ||
                  active,
                title: item.title,
              })
            : item.icon}
        </Box>

        <Box
          component="span"
          sx={{ display: mini ? 'none' : 'flex', flexDirection: 'row', gap: 0.5 }}
        >
          {item.title}{' '}
          {open ||
          openHome ||
          openDataEm ||
          openOrientation ||
          openEvalution ||
          openRecruit ||
          openReport ||
          openReward ||
          openOther ||
          openResign ? (
            item.title === 'การจัดการ' ||
            item.title === 'Home' ||
            item.title === 'ข้อมูลพนักงาน' ||
            item.title === 'ประเมิน' ||
            item.title === 'สมัครงาน' ||
            item.title === 'ลาออก' ||
            item.title === 'รายงาน' ||
            item.title === 'สวัสดิการ' ||
            item.title === 'อื่นๆ' ||
            item.title === 'ฝึกอบรม' ? (
              <CaretUpOutlined />
            ) : null
          ) : item.title === 'การจัดการ' ||
            // item.title === 'Home' ||
            item.title === 'ข้อมูลพนักงาน' ||
            item.title === 'ประเมิน' ||
            item.title === 'สมัครงาน' ||
            item.title === 'รายงาน' ||
            item.title === 'ลาออก' ||
            item.title === 'สวัสดิการ' ||
            item.title === 'อื่นๆ' ||
            item.title === 'ฝึกอบรม' ? (
            <CaretDownOutlined />
          ) : null}
        </Box>
      </ListItemButton>
      </Tooltip>

      <Collapse in={open && !mini} timeout="auto" unmountOnExit>
        {/* <ListItemButton
          component={RouterLink}
          href="/manageBranch"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isManageAllBranchActive && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_branch.svg" href="/manageBranch" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            จัดการสาขา
          </Box>
        </ListItemButton> */}
        {name?.organization?.level5 === 'ทรัพยากรบุคคล' || name?.employeeCode === '012539' ? (
          <ListItemButton
            component={RouterLink}
            href="/manageDept"
            sx={{
              pl: 4,
              gap: 2,
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              textTransform: 'capitalize',
              fontWeight: 'fontWeightMedium',
              ...(isManageDeptActive && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
                        <NavMenuIcon src="/assets/icons/navbar/ic_manageDept2.svg" href="/manageDept" />
            <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
              จัดการองค์กร
            </Box>
          </ListItemButton>
        ) : null}
        {SHOW_MANAGE_AD_MENU &&
        (name?.organization?.level5 === 'ทรัพยากรบุคคล' ||
          name?.organization?.level4 === 'เทคโนโลยีและสารสนเทศ' ||
          name?.employeeCode === '012539') ? (
          <ListItemButton
            component={RouterLink}
            href="/manageAdOrganization"
            sx={{
              pl: 4,
              gap: 2,
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              textTransform: 'capitalize',
              fontWeight: 'fontWeightMedium',
              ...(isManageAdOrganization && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
                        <NavMenuIcon src="/assets/icons/navbar/ic_chart.svg" href="/manageAdOrganization" />
            <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
              จัดการ AD
            </Box>
          </ListItemButton>
        ) : null}

        {/* <ListItemButton
          component={RouterLink}
          href="/manageEmployee"
          // disabled
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isManageAllEmployeeActive && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_allEmployee.svg" href="/manageEmployee" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            จัดการกำลังพล
          </Box>
        </ListItemButton> */}
        {name?.organization?.level5 === 'ทรัพยากรบุคคล' ||
        name?.organization?.level4 === 'เทคโนโลยีและสารสนเทศ' ||
        name?.employeeCode === '012539' ? (
          <ListItemButton
            // disabled
            component={RouterLink}
            href="/manageAssets"
            sx={{
              pl: 4,
              gap: 2,
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              textTransform: 'capitalize',
              fontWeight: 'fontWeightMedium',
              ...(isManageAssets && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
                        <NavMenuIcon src="/assets/icons/navbar/ic_manageAssets.svg" href="/manageAssets" />
            <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
              จัดการสินทรัพย์
            </Box>
          </ListItemButton>
        ) : null}
        {canManageBaiboon(name) ? (
          <ListItemButton
            component={RouterLink}
            href="/baiboonAdmin"
            sx={{
              pl: 4,
              gap: 2,
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              textTransform: 'capitalize',
              fontWeight: 'fontWeightMedium',
              ...(isBaiboonAdmin && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
            <NavMenuIcon src="/assets/icons/navbar/ic_docOther.svg" href="/baiboonAdmin" />
            <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
              น้องใบบุญ (Admin)
            </Box>
          </ListItemButton>
        ) : null}
        {name?.organization?.level5 === 'ทรัพยากรบุคคล' ||
        name?.organization?.level4 === 'เทคโนโลยีและสารสนเทศ' ||
        name?.employeeCode === '012539' ? (
          <ListItemButton
            component={RouterLink}
            href="/manageChatId"
            sx={{
              pl: 4,
              gap: 2,
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              textTransform: 'capitalize',
              fontWeight: 'fontWeightMedium',
              ...(isManageChatId && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
                        <NavMenuIcon src="/assets/icons/navbar/ic_docOther.svg" href="/manageChatId" />
            <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
              ตั้งค่า chatId
            </Box>
          </ListItemButton>
        ) : null}
        {/* <ListItemButton
          // disabled
          component={RouterLink}
          href="/testQuestions"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isTestQuestions && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_testQuestions.svg" href="/testQuestions" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            แบบทดสอบก่อนสัมภาษณ์งาน
          </Box>
        </ListItemButton> */}
      </Collapse>

      <Collapse in={openHome && !mini} timeout="auto" unmountOnExit>
        {/* <ListItemButton
          component={RouterLink}
          href="/"
          // disabled
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isDashboard && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_analytics.svg" href="/" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            แดชบอร์ด
          </Box>
        </ListItemButton>{' '} */}
      </Collapse>

      <Collapse in={openDataEm && !mini} timeout="auto" unmountOnExit>
        {name?.organization?.level5 === 'IT Development' ||
        name?.organization?.level5 === 'ทรัพยากรบุคคล' ? (
          <ListItemButton
            component={RouterLink}
            href="/manageUser"
            // disabled
            sx={{
              pl: 4,
              gap: 2,
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              textTransform: 'capitalize',
              fontWeight: 'fontWeightMedium',
              ...(isManageUser && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
                        <NavMenuIcon src="/assets/icons/navbar/ic_user.svg" href="/manageUser" />
            <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
              ข้อมูลพนักงาน
            </Box>
          </ListItemButton>
        ) : null}
        {name?.organization?.level5 === 'IT Development' ||
        name?.organization?.level5 === 'ทรัพยากรบุคคล' ? (
          <ListItemButton
            component={RouterLink}
            href="/consent"
            // disabled
            sx={{
              pl: 4,
              gap: 2,
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              textTransform: 'capitalize',
              fontWeight: 'fontWeightMedium',
              ...(isConsent && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
                        <NavMenuIcon src="/assets/icons/navbar/ic_pdpa.svg" href="/consent" />
            <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
              ข้อมูลส่วนบุคคลของพนักงาน
            </Box>
          </ListItemButton>
        ) : null}
        {name?.organization?.level5 === 'IT Development' ||
        name?.organization?.level5 === 'ทรัพยากรบุคคล' ? (
          <ListItemButton
            component={RouterLink}
            href="/manageHealth"
            // disabled
            sx={{
              pl: 4,
              gap: 2,
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              textTransform: 'capitalize',
              fontWeight: 'fontWeightMedium',
              ...(isManageHealth && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
                        <NavMenuIcon src="/assets/icons/navbar/ic_healt.svg" href="/manageHealth" />
            <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
              ประวัติสุขภาพ
            </Box>
          </ListItemButton>
        ) : null}
        {canAccessManageWelfare(name) ? (
          <ListItemButton
            component={RouterLink}
            href="/manageWelfare"
            // disabled
            sx={{
              pl: 4,
              gap: 2,
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              textTransform: 'capitalize',
              fontWeight: 'fontWeightMedium',
              ...(isManageWelfare && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
                        <NavMenuIcon src="/assets/icons/navbar/ic_welfare.svg" href="/manageWelfare" />
            <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
              ค่าเสียหาย + เงินค้ำ
            </Box>
          </ListItemButton>
        ) : null}
        {/* {name?.organization?.level5 === 'IT Development' ||
        name?.organization?.level5 === 'ทรัพยากรบุคคล' ? (
          <ListItemButton
            component={RouterLink}
            href="/employeeDamageOrLoan"
            // disabled
            sx={{
              pl: 4,
              gap: 2,
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              textTransform: 'capitalize',
              fontWeight: 'fontWeightMedium',
              ...(isEmployeeDamageOrLoan && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
                        <NavMenuIcon src="/assets/icons/navbar/ic_employeeDamageOrLoan.svg" href="/employeeDamageOrLoan" />
            <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
              ค่าความเสียหาย/เงินกู้พนักงาน
            </Box>
          </ListItemButton>
        ) : null} */}
        {/* <ListItemButton
          component={RouterLink}
          href="/myCalendar"
          // disabled
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isMyCalendar && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_myCalendar.svg" href="/myCalendar" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            ตารางงาน
          </Box>
        </ListItemButton> */}
        {/* <ListItemButton
          component={RouterLink}
          href="/reqEditCalendar"
          // disabled
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isReqEditCalendar && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_reqEditCalendar.svg" href="/reqEditCalendar" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            คำร้องขอแก้ไขตารางงาน
          </Box>
        </ListItemButton> */}
        {name?.organization?.level5 === 'IT Development' ||
        name?.organization?.level5 === 'ทรัพยากรบุคคล' ? (
          <ListItemButton
            component={RouterLink}
            href="/promoteCandidate"
            // disabled
            sx={{
              pl: 4,
              gap: 2,
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              textTransform: 'capitalize',
              fontWeight: 'fontWeightMedium',
              ...(isPromoteCandidate && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
                        <NavMenuIcon src="/assets/icons/navbar/ic_reqEmployee.svg" href="/promoteCandidate" />
            <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
              รับเข้าพนักงาน
            </Box>
          </ListItemButton>
        ) : null}
        {name?.organization?.level4 === 'เทคโนโลยีและสารสนเทศ' ||
        name?.organization?.level5 === 'เจ้าหน้าที่ทรัพยากรบุคคล' ? (
          <ListItemButton
            component={RouterLink}
            href="/prepareAssignAsset"
            // disabled
            sx={{
              pl: 4,
              gap: 2,
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              textTransform: 'capitalize',
              fontWeight: 'fontWeightMedium',
              ...(isPrepareAssignAsset && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
                        <NavMenuIcon src="/assets/icons/navbar/ic_prepareAsset.svg" href="/prepareAssignAsset" />
            <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
              เตรียมอุปกรณ์พนักงาน
            </Box>
          </ListItemButton>
        ) : null}

        {(name?.rank !== 'Trainee' &&
          name?.rank !== 'Staff' &&
          name?.rank !== 'Senior I' &&
          name?.rank !== 'Senior II' &&
          name?.rank !== 'Senior III') ||
        name?.organization?.level5 === 'ทรัพยากรบุคคล' ||
        name?.employeeCode === '012539' ? (
          <ListItemButton
            component={RouterLink}
            href="/reqEmployee"
            // disabled
            sx={{
              pl: 4,
              gap: 2,
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              textTransform: 'capitalize',
              fontWeight: 'fontWeightMedium',
              ...(isReqEmployee && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
                        <NavMenuIcon src="/assets/icons/navbar/ic_recruitment.svg" href="/reqEmployee" />
            <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
              ร้องขอกำลังพล
            </Box>
          </ListItemButton>
        ) : null}
        {(name?.rank !== 'Trainee' &&
          name?.rank !== 'Staff' &&
          name?.rank !== 'Senior I' &&
          name?.rank !== 'Senior II' &&
          name?.rank !== 'Senior III') ||
        name?.organization?.level5 === 'ทรัพยากรบุคคล' ||
        name?.employeeCode === '012539' ? (
          <ListItemButton
            component={RouterLink}
            href="/approveReqList"
            // disabled
            sx={{
              pl: 4,
              gap: 2,
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              textTransform: 'capitalize',
              fontWeight: 'fontWeightMedium',
              ...(isApproveReqList && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
                        <NavMenuIcon src="/assets/icons/navbar/ic_listReqEmployee.svg" href="/approveReqList" />
            <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
              รายการคำร้องขอกำลังพล
            </Box>
          </ListItemButton>
        ) : null}
      </Collapse>

      <Collapse in={openOrientation && !mini} timeout="auto" unmountOnExit>
        <ListItemButton
          component={RouterLink}
          href="/trainingData"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isTrainingData && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_orientation.svg" href="/trainingData" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            ข้อมูลการฝึกอบรม
          </Box>
        </ListItemButton>
        <ListItemButton
          component={RouterLink}
          href="/trainingPlan"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isTrainingPlan && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
          <NavMenuIcon src="/assets/icons/navbar/ic_orientation.svg" href="/trainingPlan" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            สร้างแผนอบรมประจำปี
          </Box>
        </ListItemButton>
        <ListItemButton
          component={RouterLink}
          href="/trainingSkillNeed"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isTrainingSkillNeed && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
          <NavMenuIcon src="/assets/icons/navbar/ic_orientation.svg" href="/trainingSkillNeed" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            Skill Need / แผนอบรม
          </Box>
        </ListItemButton>
        <ListItemButton
          component={RouterLink}
          href="/trainingCompliance"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isTrainingCompliance && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
          <NavMenuIcon src="/assets/icons/navbar/ic_trainingRequest.svg" href="/trainingCompliance" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            อบรมตามกฎหมาย
          </Box>
        </ListItemButton>
        <ListItemButton
          component={RouterLink}
          href="/trainingDsd"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isTrainingDsd && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
          <NavMenuIcon src="/assets/icons/navbar/ic_orientation.svg" href="/trainingDsd" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            ขอรับรองหลักสูตร (กรมพัฒนาฯ)
          </Box>
        </ListItemButton>
        <ListItemButton
          component={RouterLink}
          href="/trainingCertificate"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isTrainingCertificate && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
          <NavMenuIcon src="/assets/icons/navbar/ic_trainingRequest.svg" href="/trainingCertificate" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            ออก Certificate
          </Box>
        </ListItemButton>
        {/* <ListItemButton
          component={RouterLink}
          href="/orientation"
          // disabled
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isOrientation && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_orientationSub.svg" href="/orientation" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            Orientation
          </Box>
        </ListItemButton> */}
        <ListItemButton
          component="a"
          href="http://192.168.10.154/bsrtraining"
          target="_blank" // เปิดในแท็บใหม่
          rel="noopener noreferrer"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isPromoteCandidate && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_streaming.svg" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            ระบบ Streaming
          </Box>
        </ListItemButton>
        {/* <ListItemButton
          component={RouterLink}
          href="/trainingHistory"
          // disabled
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isTrainingHistory && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_trainingHostory.svg" href="/trainingHistory" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            ประวัติการฝึกอบรม
          </Box>
        </ListItemButton> */}
        <ListItemButton
          component={RouterLink}
          href="/trainingRequest"
          // disabled
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isTrainingRequest && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_trainingRequest.svg" href="/trainingRequest" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            ร้องขอฝึกอบรม
          </Box>
        </ListItemButton>
      </Collapse>

      <Collapse in={openEvalution && !mini} timeout="auto" unmountOnExit>
        {canSeeEvalHrMenus(name) ? (
          <ListItemButton
            component={RouterLink}
            href="/probationEva"
            // disabled
            sx={{
              pl: 4,
              gap: 2,
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              textTransform: 'capitalize',
              fontWeight: 'fontWeightMedium',
              ...(isProbationEva && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
                        <NavMenuIcon src="/assets/icons/navbar/ic_probationEva.svg" href="/probationEva" />
            <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
              รายการประเมินทดลองงานทั้งหมด
            </Box>
          </ListItemButton>
        ) : null}

          <ListItemButton
            component={RouterLink}
            href="/probationEvaMe"
            // disabled
            sx={{
              pl: 4,
              gap: 2,
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              textTransform: 'capitalize',
              fontWeight: 'fontWeightMedium',
              ...(isProbationEvaMe && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
                        <NavMenuIcon src="/assets/icons/navbar/ic_probationEva.svg" href="/probationEvaMe" />
            <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
              รายการประเมินทดลองงานของฉัน
            </Box>
          </ListItemButton>

        <ListItemButton
          component={RouterLink}
          href="/probationEvaYear"
          rel="noopener noreferrer"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isProbationEvaYear && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
          <Badge
            overflowCount={Infinity}
            style={{ fontFamily: 'Noto Sans Thai' }}
            count={filteredEvaAll?.length || 0}
            size="small"
          >
                        <NavMenuIcon src="/assets/icons/navbar/ic_proEvaYear.svg" href="/probationEvaYear" />
          </Badge>

          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            รายการทั้งหมด
          </Box>
        </ListItemButton>
        <ListItemButton
          component={RouterLink}
          href="/probationEvaYearMe"
          rel="noopener noreferrer"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isProbationEvaYearMe && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
          <Badge
            overflowCount={Infinity}
            style={{ fontFamily: 'Noto Sans Thai' }}
            count={myFiltered.filter((d) => d.evaluationStatus === 'PENDING')?.length || 0}
            size="small"
          >
                        <NavMenuIcon src="/assets/icons/navbar/ic_proEvaYear.svg" />
          </Badge>

          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            รายการของฉัน
          </Box>
        </ListItemButton>
        <ListItemButton
          component={RouterLink}
          href="/summaryProbationEvaYear"
          rel="noopener noreferrer"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isSummaryProbationEvaYear && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
          <Badge
            overflowCount={Infinity}
            style={{ fontFamily: 'Noto Sans Thai' }}
            count={results.length || 0}
            size="small"
          >
                        <NavMenuIcon src="/assets/icons/navbar/ic_proEvaYear.svg" href="/summaryProbationEvaYear" />
          </Badge>
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            สรุปประจำปี
          </Box>
        </ListItemButton>
        <ListItemButton
          component={RouterLink}
          href="/summaryKpiProbationEvaYear"
          rel="noopener noreferrer"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isKpiProbationEvaYear && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
          <Badge
            overflowCount={Infinity}
            style={{ fontFamily: 'Noto Sans Thai' }}
            count={filtered.length || 0}
            size="small"
          >
                        <NavMenuIcon src="/assets/icons/navbar/ic_proEvaYear.svg" href="/summaryKpiProbationEvaYear" />
          </Badge>
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            สรุป KPI
          </Box>
        </ListItemButton>
        <ListItemButton
          component={RouterLink}
          href="/behaviorDisciplineEvaYear"
          rel="noopener noreferrer"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isBehaviorDisciplineEvaYear && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
          <Badge
            overflowCount={Infinity}
            style={{ fontFamily: 'Noto Sans Thai' }}
            count={resultsBehavior.length || 0}
            size="small"
          >
                        <NavMenuIcon src="/assets/icons/navbar/ic_proEvaYear.svg" />
          </Badge>

          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            สรุปพฤติกรรมและวินัย
          </Box>
        </ListItemButton>
        <ListItemButton
          component={RouterLink}
          href="/evaluationSkillGap"
          rel="noopener noreferrer"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isEvaluationSkillGap && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
          <NavMenuIcon src="/assets/icons/navbar/ic_skillGap.svg" href="/evaluationSkillGap" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            สรุปผล + Skill Gap
          </Box>
        </ListItemButton>
        <ListItemButton
          component={RouterLink}
          href="/talentNineBox"
          rel="noopener noreferrer"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isTalentNineBox && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
          <NavMenuIcon src="/assets/icons/navbar/ic_nineBox.svg" href="/talentNineBox" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            9-Box Talent
          </Box>
        </ListItemButton>
        <ListItemButton
          component={RouterLink}
          href="/evaluationOkr"
          rel="noopener noreferrer"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isEvaluationOkr && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
          <NavMenuIcon src="/assets/icons/navbar/ic_skillGap.svg" href="/evaluationOkr" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            OKRs
          </Box>
        </ListItemButton>
        <ListItemButton
          component={RouterLink}
          href="/evaluationPeerSummary"
          rel="noopener noreferrer"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isEvaluationPeerSummary && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
          <NavMenuIcon src="/assets/icons/navbar/ic_allEmployee.svg" href="/evaluationPeerSummary" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            สรุป Peer 360°
          </Box>
        </ListItemButton>
        <ListItemButton
          component={RouterLink}
          href="/evaluationRetention"
          rel="noopener noreferrer"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isEvaluationRetention && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
          <NavMenuIcon src="/assets/icons/navbar/ic_healt.svg" href="/evaluationRetention" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            สัญญาณเตือน Retention
          </Box>
        </ListItemButton>
        {isEvaluationHr(name) ? (
          <ListItemButton
            component={RouterLink}
            href="/settingTest"
            rel="noopener noreferrer"
            sx={{
              pl: 4,
              gap: 2,
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              textTransform: 'capitalize',
              fontWeight: 'fontWeightMedium',
              ...(isSettingTest && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
                        <NavMenuIcon src="/assets/icons/navbar/ic_settingTest.svg" href="/settingTest" />
            <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
              ตั้งค่า
            </Box>
          </ListItemButton>
        ) : null}
        {/* <ListItemButton
          component={RouterLink}
          href="/testTalentAssessment"
          rel="noopener noreferrer"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isTestTalentAssessment && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_talent.svg" href="/testTalentAssessment" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            Talent Assessment
          </Box>
        </ListItemButton> */}
        {/* <ListItemButton
          component={RouterLink}
          href="/reportEvaluation"
          // disabled
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isReportEvaluation && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_reportEvaluation.svg" href="/reportEvaluation" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            รายงาน
          </Box>
        </ListItemButton>
        <ListItemButton
          component={RouterLink}
          href="/dashboardProbationEva"
          // disabled
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isDashboardProbationEva && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_sumProEva.svg" href="/dashboardProbationEva" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            สรุปประเมินทดลองงาน
          </Box>
        </ListItemButton>
        <ListItemButton
          component={RouterLink}
          href="/dashboardProbationEvaYear"
          // disabled
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isDashboardProbationEvaYear && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_sumProEva.svg" href="/dashboardProbationEvaYear" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            สรุปประเมินประจำปี
          </Box>
        </ListItemButton> */}
      </Collapse>

      <Collapse in={openRecruit && !mini} timeout="auto" unmountOnExit>
        {name?.organization?.level5 === 'IT Development' ||
        name?.organization?.level5 === 'ทรัพยากรบุคคล' ||
        name?.isRecruiter ? (
          <ListItemButton
            component={RouterLink}
            href="/listRecruit"
            // disabled
            sx={{
              pl: 4,
              gap: 2,
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              textTransform: 'capitalize',
              fontWeight: 'fontWeightMedium',
              ...(isListRecruit && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
            <Badge
              overflowCount={Infinity}
              style={{ fontFamily: 'Noto Sans Thai' }}
              count={data?.getAllJobApplications.filter((row) => row.interest === null).length}
              size="small"
            >
                            <NavMenuIcon src="/assets/icons/navbar/ic_listRecruit.svg" />
            </Badge>
            <Box
              component="span"
              sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: 1,
                fontFamily: 'Noto Sans Thai',
                typography: 'body2',
                color: 'text.secondary',
                fontFamily: 'Noto Sans Thai',
                textTransform: 'capitalize',
                fontWeight: 'fontWeightMedium',
              }}
            >
              รายการคำร้องขอสมัครงาน
            </Box>
          </ListItemButton>
        ) : null}
         {name?.organization?.level5 === 'IT Development' ||
        name?.organization?.level5 === 'ทรัพยากรบุคคล' ? (
          <ListItemButton
            component={RouterLink}
            href="/manageTest"
            // disabled
            sx={{
              pl: 4,
              gap: 2,
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              textTransform: 'capitalize',
              fontWeight: 'fontWeightMedium',
              ...(isManageTest && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
       
                            <NavMenuIcon src="/assets/icons/navbar/ic_test.svg" href="/manageTest" />
            <Box
              component="span"
              sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: 1,
                fontFamily: 'Noto Sans Thai',
                typography: 'body2',
                color: 'text.secondary',
                fontFamily: 'Noto Sans Thai',
                textTransform: 'capitalize',
                fontWeight: 'fontWeightMedium',
              }}
            >
              จัดการข้อสอบ
            </Box>
          </ListItemButton>
        ) : null}

        {name?.organization?.level5 === 'IT Development' ||
        name?.organization?.level5 === 'ทรัพยากรบุคคล' ||
        name?.isRecruiter ? (
          <ListItemButton
            component={RouterLink}
            href="/candidateEvaluation"
            rel="noopener noreferrer"
            sx={{
              pl: 4,
              gap: 2,
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              textTransform: 'capitalize',
              fontWeight: 'fontWeightMedium',
              ...(isCandidateEvaluation && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
            <Badge
              overflowCount={Infinity}
              style={{ fontFamily: 'Noto Sans Thai' }}
              count={
                data?.getAllJobApplications.filter((row) => row.status === 'สัมภาษณ์เสร็จสิ้น')
                  .length
              }
              size="small"
            >
                            <NavMenuIcon src="/assets/icons/navbar/ic_candidateEvaluation.svg" />
            </Badge>
            <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
              ประเมินผู้สมัครงาน
            </Box>
          </ListItemButton>
        ) : null}

        {name?.organization?.level5 === 'ทรัพยากรบุคคล' || name?.employeeCode === '012539' ? (
          <ListItemButton
            component={RouterLink}
            href="/deptOpen"
            // disabled
            sx={{
              pl: 4,
              gap: 2,
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              textTransform: 'capitalize',
              fontWeight: 'fontWeightMedium',
              ...(isDeptOpen && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
                        <NavMenuIcon src="/assets/icons/navbar/ic_deptOpen.svg" href="/deptOpen" />
            <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
              ตำแหน่งที่เปิดรับสมัคร
            </Box>
          </ListItemButton>
        ) : null}

        <Box sx={{ width: '100%' }}>
          {name?.organization?.level5 === 'ทรัพยากรบุคคล' || name?.employeeCode === '012539' ? (
            <ListItemButton
              component={RouterLink}
              href="/applicationArchive"
              // disabled
              sx={{
                pl: 4,
                gap: 2,
                minHeight: 44,
                borderRadius: 0.75,
                typography: 'body2',
                color: 'text.secondary',
                fontFamily: 'Noto Sans Thai',
                textTransform: 'capitalize',
                fontWeight: 'fontWeightMedium',
                ...(isApplicationArchive && {
                  color: 'primary.main',
                  fontWeight: 'fontWeightSemiBold',
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                  '&:hover': {
                    bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                  },
                }),
              }}
            >
              <Badge
                overflowCount={Infinity}
                style={{ fontFamily: 'Noto Sans Thai' }}
                count={data?.getAllJobApplications.filter((row) => row.interest).length}
                size="small"
              >
                                <NavMenuIcon src="/assets/icons/navbar/ic_applicationArchive.svg" />
              </Badge>
              <Box
                component="span"
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 1,
                  fontFamily: 'Noto Sans Thai',
                  typography: 'body2',
                  color: 'text.secondary',
                  fontFamily: 'Noto Sans Thai',
                  textTransform: 'capitalize',
                  fontWeight: 'fontWeightMedium',
                }}
              >
                คลังใบสมัครงาน
              </Box>
            </ListItemButton>
          ) : null}
        </Box>
      </Collapse>

      <Collapse in={openResign && !mini} timeout="auto" unmountOnExit>
        {/* <ListItemButton
          component={RouterLink}
          href="/resignation"
          // disabled
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isResignation && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_resignation.svg" href="/resignation" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            แจ้งความประสงค์ลาออก
          </Box>
        </ListItemButton> */}
        <ListItemButton
          component={RouterLink}
          href="/resignationList"
          rel="noopener noreferrer"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isResignationList && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_resignationList.svg" href="/resignationList" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            รายการพนักงานแจ้งลาออก
          </Box>
        </ListItemButton>
      </Collapse>

      <Collapse in={openReport && !mini} timeout="auto" unmountOnExit>
        {/* <ListItemButton
          component={RouterLink}
          href="/reportEmployee"
          // disabled
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isReportEmployee && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_reportEmployee.svg" href="/reportEmployee" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            รายงานกำลังพล
          </Box>
        </ListItemButton> */}
        <ListItemButton
          component={RouterLink}
          href="/organizationalChart"
          rel="noopener noreferrer"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isOrganizationalChart && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_chart.svg" href="/organizationalChart" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            ผังองค์กร
          </Box>
        </ListItemButton>
        {canAccessOtCosting(name) ? (
          <ListItemButton
            component={RouterLink}
            href="/otCosting"
            sx={{
              pl: 4,
              gap: 2,
              minHeight: 44,
              borderRadius: 0.75,
              typography: 'body2',
              color: 'text.secondary',
              fontWeight: 'fontWeightMedium',
              ...(isOtCosting && {
                color: 'primary.main',
                fontWeight: 'fontWeightSemiBold',
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                '&:hover': {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                },
              }),
            }}
          >
            <NavMenuIcon src="/assets/icons/navbar/ic_analytics.svg" href="/otCosting" />
            <Box component="span">OT Report (Costing)</Box>
          </ListItemButton>
        ) : null}
        {/* <ListItemButton
          component={RouterLink}
          href="/reportResign"
          rel="noopener noreferrer"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isReportResign && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_reportResign.svg" href="/reportResign" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            รายงานพนักงานลาออก
          </Box>
        </ListItemButton> */}
      </Collapse>

      <Collapse in={openReward && !mini} timeout="auto" unmountOnExit>
        {/* <ListItemButton
          component={RouterLink}
          href="/leaderBoard"
          // disabled
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isLeaderBoard && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_leaderboard.svg" href="/leaderBoard" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            Leaderboard
          </Box>
        </ListItemButton> */}
        <ListItemButton
          component={RouterLink}
          href="/claim"
          // disabled
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isClaim && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_claim.svg" href="/claim" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            เบิกสวัสดิการ
          </Box>
        </ListItemButton>
        <ListItemButton
          component={RouterLink}
          href="/transferRequest"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isTransferRequest && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
          <NavMenuIcon src="/assets/icons/navbar/ic_manageDept2.svg" href="/transferRequest" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            แจ้งโยกย้าย
          </Box>
        </ListItemButton>
        {/* <ListItemButton
          component={RouterLink}
          href="/reward"
          rel="noopener noreferrer"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isReward && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_rewardSub.svg" href="/reward" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            Reward
          </Box>
        </ListItemButton> */}
      </Collapse>

      <Collapse in={openOther && !mini} timeout="auto" unmountOnExit>
        <ListItemButton
          component={RouterLink}
          href="/docOther"
          // disabled
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isDocOther && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_docOther.svg" href="/docOther" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            ประกาศ/ระเบียบ
          </Box>
        </ListItemButton>
        <ListItemButton
          component="a"
          href="https://report.boonsiri.co.th/reportForm.php"
          target="_blank" // เปิดในแท็บใหม่
          rel="noopener noreferrer"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isReportSys && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_report.svg" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            ระบบร้องเรียน
          </Box>
        </ListItemButton>
        {/* <ListItemButton
          component={RouterLink}
          href="/document"
          sx={{
            pl: 4,
            gap: 2,
            minHeight: 44,
            borderRadius: 0.75,
            typography: 'body2',
            color: 'text.secondary',
            textTransform: 'capitalize',
            fontWeight: 'fontWeightMedium',
            ...(isDocument && {
              color: 'primary.main',
              fontWeight: 'fontWeightSemiBold',
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
              '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
              },
            }),
          }}
        >
                    <NavMenuIcon src="/assets/icons/navbar/ic_document.svg" href="/document" />
          <Box component="span" sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            เอกสารฯ
          </Box>
        </ListItemButton> */}
      </Collapse>
    </>
  );
}

NavItem.propTypes = {
  item: PropTypes.object,
};
